import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import * as graph from '@adc/sdk'
import { GridDeprecated } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { formatAuctionDate } from '../../utils/event'
import STATICS from '../../statics'
import styles from './styles.scss'

const { EventType } = graph.enums

const EVENT_TYPE_MAPPING = {
  [EventType.LIVE]: 'In-Person',
  [EventType.ONLINE]: 'Online',
  [EventType.THIRD_PARTY]: '3rd Party',
}

const { Row, Column } = GridDeprecated
const cx = classnames.bind(styles)

const EventRow = ({ event, index }) => {
  const [venueStarts, venueEnds] = event.venues
    .reduce(
      (acc, venue) => {
        acc[0].push(moment(venue.venue_schedule?.bid_start_local_date))
        acc[1].push(
          moment(venue.venue_schedule?.initial_bidding_end_local_date)
        )

        return acc
      },
      [[], []]
    )
    .map(dates => dates.filter(d => d.isValid()))

  // NOTE: We need to do a length check here because moment has interesting behavior where the max of a list of empty
  // dates will always return the current date, which is certainly not what we want.
  const formattedAuctionDate = formatAuctionDate(
    venueStarts.length ? moment.min(venueStarts) : null,
    venueEnds.length ? moment.max(venueEnds) : null
  )

  return (
    <div>
      <Row className={cx('calendar-table-body')}>
        <Column medium={3} className={cx('calendar-table-body-column')}>
          <div className={cx('calendar-table-body-date-container')}>
            <h4
              data-elm-id={`calendar_table_body_header_dates_${index}`}
              className={cx('calendar-table-body-column-header', 'mobile-only')}
            >
              {STATICS.HEADER_LABEL_DATES_TYPE}
            </h4>
            <p
              className={cx('calendar-table-label')}
              data-elm-id={`auction_date_${index}`}
            >
              {formattedAuctionDate}{' '}
              <span className={cx('mobile-only', 'calendar-table-label-date')}>
                | {event.event_type}
              </span>
            </p>
            <p
              className={cx('calendar-table-label', 'desktop-only')}
              data-elm-id={`event_type_${index}`}
            >
              {EVENT_TYPE_MAPPING[event.event_type]}
              {event.event_configuration?.is_offer_enabled && ` - Direct Offer`}
            </p>
          </div>
        </Column>
        <Column medium={6} className={cx('calendar-table-body-column')}>
          <h4
            data-elm-id={`calendar_table_body_header_name_${index}`}
            className={cx('calendar-table-body-column-header', 'mobile-only')}
          >
            {STATICS.HEADER_LABEL_EVENT_NAME}
          </h4>
          <a
            data-elm-id={`calendar_table_sender_link_${index}`}
            href={`/event/details/${event.event_code}`.toLowerCase()}
          >
            {' '}
            {event.title}{' '}
          </a>
        </Column>
        <Column medium={3} className={cx('calendar-table-body-column')}>
          <h4
            data-elm-id={`calendar_table_body_header_total_${index}`}
            className={cx('calendar-table-body-column-header', 'mobile-only')}
          >
            {STATICS.HEADER_LABEL_ASSETS_TOTAL}
          </h4>
          <p
            data-elm-id={`label_calendar_assets_type_${index}`}
            className={cx('calendar-table-label')}
          >
            {event.trustee_sale ? 'Foreclosure' : 'REO Bank Owned'}
          </p>
          <p
            className={cx('calendar-table-label')}
            data-elm-id={`label_calendar_assets_count_${index}`}
          >
            Assets: {event.listing_count || 0}
          </p>
        </Column>
      </Row>
    </div>
  )
}

EventRow.propTypes = {
  event: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

export default EventRow
